<template>
  <div class="sidebar-content sidebar-content--sleeves">
    <h1 class="sidebar-title">Pocket Color</h1>
    <h3 class="sidebar-subtitle">Pick Pockets Color</h3>
    <div class="canvas-wrap">
      <svg id="background" width="100%" height="100%">
        <rect width="100%" height="100%" :fill="bodyColor.hex" fill-opacity="0.9"/>
      </svg>
      <div id="pocket-canvas">
      </div>
    </div>
    <b-button
      class="btn"
      @click="resetToMatchSleeves"
      size="sm"
    >Match Pocket Color to Sleeves</b-button>
    <ColorPicker
      :colors="colorsCategories.pocketsColors"
      @onSelectColor="onSelectColor"
    />
    <div class="color-label">Selected Color:</div>
    <b>{{ pocketsColor.title }}</b>
  </div >
</template>

<script>
import * as SVG from 'svg.js/dist/svg';
import PocketSVG from '@/assets/pocket/pocket.svg';
import ColorPicker from '@/components/common/ColorPicker.vue';
import { mixin as clickaway } from 'vue-clickaway';
import svgApi from '@/api/svgApi';

export default {
  name: 'PocketsSidebar',
  components: {
    ColorPicker,
  },
  mixins: [clickaway],
  data () {
    return {
      colors: [],
      pocketCanvasId: '',
      pocketCanvas: null,
      pocketCanvasWidth: 0,
      pocketCanvasHeight: 0,
      editModePocketColor: false,
      isPocketColorChangeSeparately: false,
    };
  },

  mounted () {
    this.initPocketCanvas();
    this.loadPocket();
  },
  watch: {
    pocketsColor () {
      this.pocketCanvas.select('#pocket').fill(this.pocketsColor.hex);
    },
  },
  computed: {
    isChangePocketColor () {
      return this.$store.getters['design/getIsChangePocketsColor'];
    },
    bodyColor () {
      return this.$store.getters['design/getBodyColor'];
    },
    sleevesColor () {
      return this.$store.getters['design/getSleevesColor'];
    },
    pocketsColor () {
      return this.$store.getters['design/getPocketsColor'];
    },
    colorsCategories () {
      return this.$store.getters['elements/getColorsCategories'];
    },
  },

  methods: {
    resetToMatchSleeves () {
      this.pocketCanvas.select('#pocket').fill(this.sleevesColor.hex);
      this.$store.commit('design/setPocketsColor', { color: this.sleevesColor });
      this.$store.commit('design/setIsChangePocketsColor', false);
    },
    initPocketCanvas () {
      this.pocketCanvasWidth = document.getElementById('pocket-canvas').offsetWidth;
      this.pocketCanvasHeight = document.getElementById('pocket-canvas').offsetHeight;
      this.pocketCanvas = SVG('pocket-canvas').size(this.pocketCanvasWidth, this.pocketCanvasHeight);
      this.pocketCanvasId = this.pocketCanvas.node.id;
    },

    loadPocket () {
      svgApi.loadLocalSvg(PocketSVG).then((svgText) => {
        this.pocketCanvas.svg(svgText);
        this.pocketCanvas.select('svg').last()
          .width(100)
          .height(250)
          .id('jacket-pocket')
          .cx(this.pocketCanvas.cx())
          .cy(this.pocketCanvas.cy());
        this.pocketCanvas.select('#pocket').fill(this.pocketsColor.hex);
      });
    },
    onSelectColor (color) {
      this.$store.commit('design/setPocketsColor', { color });
      this.$store.commit('design/setIsChangePocketsColor', true);
    },
  }
};
</script>

<style scoped>
.canvas-wrap {
  position: relative;
  height: 250px;
  margin-bottom: 20px;
  border: 1px solid black;
}
#background {
  position: absolute;
  top: 0;
  left: 0;
}
#pocket-canvas {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 2;
}
.popover {
}
.btn {
  margin-bottom: 20px;
}
.color-label {
  margin-top: 10px;
}
</style>
